import Api from "./Api";

export default {
  getShipTypes(obj) {
    return Api().post("shipType", obj);
  },
};
